import {
  BankInterface,
  BankActionInterface,
  BankSocketPriority,
} from "../interfaces/Bank.interface";
import { LiftType } from "../flatbuffers/generated/archive/lift-type";
import { ActionButtonType } from "../flatbuffers/generated/archive/action-button-type";

// eslint-disable-next-line import/prefer-default-export
export const BLANK_BANK: BankInterface = {
  id: null,
  name: "",
  type: LiftType.ELEVATOR,
  channelId: null,
  adapterId: null,
  orgId: null,
  stops: 0,
  numberOfLifts: 0,
  logicalPort: 0,
  floorCount: 0,
  floorBelowLobby: 0,
  rearDoors: false,
  active: true,
  visible: true,
  startFloorNo: 1,
  columns: 0,
  eventReportingAddress: null,
  createdAt: null,
  updatedAt: null,
  deletedAt: null,
};

export const BLANK_BANK_ACTION: BankActionInterface = {
  id: "",
  bankId: "",
  messageId: "",
  color: "#38ac68",
  timer: 1,
  label: "",
  validStates: [],
  toggleMessageId: "",
  toggleColor: "#f94d4f",
  toggleTimer: 1,
  toggleLabel: "",
  toggleValidStates: [],
  buttonType: ActionButtonType[ActionButtonType.TOGGLE] as BankActionInterface["buttonType"],
  createdAt: "",
};

export const DEFAULT_MONITORING_PRIORITY: BankSocketPriority = {
  activeLevel: 1,
  messageTypes: [],
};
